import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface VoiceChoice {
  value: string
  label: string
}

interface VoiceChoicesResponse {
  choices: VoiceChoice[]
}

/**
 * GET /api/voice-choices/ — the TTS voices of a carrier (Twilio by default).
 * A number only offers the voices its own carrier reads.
 */
export function useVoiceChoices(fournisseur: 'twilio' | 'telnyx' = 'twilio') {
  return useQuery({
    queryKey: fournisseur === 'twilio' ? ['voice-choices'] : ['voice-choices', fournisseur],
    queryFn: async () => {
      const { data } = await api.get<VoiceChoicesResponse>('/api/voice-choices/', {
        params: fournisseur === 'twilio' ? undefined : { fournisseur },
      })
      return data.choices ?? []
    },
    staleTime: Infinity,
  })
}
